import { Footer } from 'antd/es/layout/layout';


export const AdminFooter = ({children}) => (
    <Footer className="text-center text-gray-600">{children}</Footer>
);